// extracted by mini-css-extract-plugin
export default {"card-header":"UserAdminAccount_card-header__LSJ3+","account-row":"UserAdminAccount_account-row__d1Pwj","button-width":"UserAdminAccount_button-width__x56hQ"};